const fetchSongs = async () => {
  try {
    const response = await fetch('https://admin.therealestt.site/api/songs');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.data; // Array of songs
  } catch (error) {
    console.error('Failed to fetch songs:', error);
    // Return empty array to trigger fallback to placeholderData
    throw error;
  }
};

export { fetchSongs };